import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

/* Route-guard voor admin-only pagina's (Regie, Setup-hub, Beheer, Schermregie…).
   Backend blokkeert API-calls al met 403, maar zonder deze guard rendert de
   frontend voor een gewone user een lege/kapotte admin-shell — verwarrend en
   soms lekt hij structurele info. Wie geen 'admin' of 'superadmin' is wordt
   naar de home gestuurd. */
export default function RequireAdmin({ children }) {
  const { user } = useAuth()
  const location = useLocation()

  const rol = user?.role
  const isAdmin = rol === 'admin' || rol === 'superadmin'
  if (!isAdmin) {
    return <Navigate to="/" replace state={{ from: location.pathname + location.search }} />
  }
  // Zowel als route-element (met <Outlet />) als inline-wrapper (met children).
  return children ?? <Outlet />
}
